import React from 'react'
import ReactDOM from 'react-dom'
import Link from 'gatsby-link'

class ObjectGrid extends React.Component {
  state = { objectdata: [] }

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    //get the object data
    const objid = this.props.objectid
    fetch('https://data.artmuseum.princeton.edu/objects/' + objid)
      .then(res => res.json())
      .then(objectdata => this.setState({ objectdata }))
  }

  render() {
    let date
    if (this.state.objectdata.displaydate) {
      date = ', ' + this.state.objectdata.displaydate }

    return (
      <div className="object-grid">
      <Link to={ '/objects/' + this.props.objectid }>
        <div className="object-grid__thumbnail">
          <img
            src={
              this.state.objectdata.primaryimage + '/full/!150,150/0/default.jpg'
            }
          />
        </div>
        <div className="object-grid__tombstone">
          <div>{this.state.objectdata.displayperiod}</div>
          <div>{this.state.objectdata.displaymaker}</div>
          <div>
              <strong>{this.state.objectdata.displaytitle}</strong>{date}
          </div>
        </div>
      </Link>
      </div>
    )
  }
}

export default ObjectGrid



// WEBPACK FOOTER //
// ./src/components/ObjectGrid.js